import { render } from "./SubscriptionTag.vue?vue&type=template&id=81455336&scoped=true"
import script from "./SubscriptionTag.vue?vue&type=script&lang=js"
export * from "./SubscriptionTag.vue?vue&type=script&lang=js"

import "./SubscriptionTag.vue?vue&type=style&index=0&id=81455336&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81455336"]])

export default __exports__